export const LOCALE_CS_CZ = 'cs-CZ';
export const LOCALE_EN_US = 'en-US';
export const LOCALE_ES_ES = 'es-ES';
export const LOCALE_FR_FR = 'fr-FR';
export const LOCALE_NL_NL = 'nl-NL';
